import { render, staticRenderFns } from "./CreateBannerPage.vue?vue&type=template&id=e716b522&scoped=true"
import script from "./CreateBannerPage.vue?vue&type=script&lang=js"
export * from "./CreateBannerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e716b522",
  null
  
)

export default component.exports